<script setup lang="ts">
const { locale, t } = useI18n()

const hours = useState()
const days = useState()

await callOnce(() => {
  const { 0: monday, 4: friday } = getWeekdays(locale.value, 'short')
  days.value = `${monday} - ${friday}`

  const { 6: six, 18: eighteen } = getHours(locale.value)
  hours.value = `${six} - ${eighteen}`
})
const config = useRuntimeConfig()

const expressShippingTime = computed(() => {
  const min = +config.public.expressShippingTime.min
  const max = +config.public.expressShippingTime.max
  return { min, max }
})
const { isMobile } = useDevice()
</script>

<template>
  <div class="h-10 bg-black text-white">
    <LazyNTinyCarousel v-if="isMobile" :items="3" class="h-10 lg:hidden">
      <template #slide-0>
        <span class="box-border min-w-0 flex items-center justify-center bg-transparent px-0 py-3 text-xs fw600 uppercase">
          <Icon name="i-lucide:truck" class="relative me-0.5 box-border aspect-square size-4 object-contain" aria-hidden="true" />
          <span class="ms-2.5 fw700"> {{ `${t('product.fastest_delivery.label')} ${t('delivery.within_n_working_days', expressShippingTime.min)}` }}</span>
        </span>
      </template>
      <template #slide-1>
        <span class="box-border min-w-0 flex items-center justify-center bg-transparent px-0 py-3 text-xs fw600 uppercase">
          <Icon name="i-lucide:gift" class="relative me-0.5 box-border aspect-square size-4 object-contain" aria-hidden="true" />
          <span class="ms-2.5 fw700">{{ t('incentives.gift_with_every_purchase.title') }}</span>
        </span>
      </template>

      <template #slide-2>
        <span class="box-border min-w-0 flex items-center justify-center bg-transparent px-0 py-3 text-xs fw600 uppercase">
          <Icon name="i-lucide:clock" class="relative me-0.5 box-border aspect-square size-4 object-contain" aria-hidden="true" />
          <span class="ms-2.5 fw700">{{ t('customer_service.days_and_hours', { hours, days }) }}</span>
        </span>
      </template>
    </LazyNTinyCarousel>

    <div v-else class="relative mx-auto h-10 w-full flex bg-black hidden lg:block">
      <div class="mx-auto h-full max-w-3xl flex items-center justify-center lg:max-w-[88rem] md:max-w-4xl lg:px6">
        <div class="h-full w-full flex flex-row items-center justify-between ws-nowrap py0 lg:px0">
          <span class="flex items-center px2.5 py0">
            <Icon name="i-lucide:gift" class="me2.5 size-4 text-white" />
            <span class="w-fit ws-break-spaces text-xs text-white fw700 uppercase">
              {{ t('incentives.gift_with_every_purchase.title') }}
            </span>
          </span>

          <span class="flex items-center px2.5 py0">
            <Icon name="i-lucide:truck" class="me2.5 size-4 text-white" />
            <span class="w-fit ws-break-spaces text-xs text-white fw700 uppercase">
              {{ `${t('product.fastest_delivery.label')} ${t('delivery.within_n_working_days', expressShippingTime.min)}` }}
            </span>
          </span>

          <span class="flex items-center px2.5 py0">
            <Icon name="i-lucide:truck" class="me2.5 size-4 text-white" />
            <span class="w-fit ws-break-spaces text-xs text-white fw700 uppercase">
              {{ t('policies.free_shipping') }}
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
